<template>
  <div
    class="container-tooltip position-absolute"
    :class="
      position == 'top' ? 'container-tooltip-position-top' : 'container-tooltip-position-bottom'
    "
  >
    <div class="d-flex flex-column align-items-center">
      <p class="tooltip-title">{{ title }}</p>
      <p class="tooltip-text">
        {{ text }}
      </p>
      <Button color="green" :to="target" @click.native="clickNativeAction">{{ buttonText }}</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/UI/Button';

export default {
  name: 'DownloadTooltip',
  components: {
    Button
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'top'
    },
    clickNativeAction: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.container-tooltip {
  max-width: 367px;
  z-index: 100;
  padding: 25px;
  width: 100%;
  text-align: center;

  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 22px #00000029;
  border-radius: 15px;

  &-position-top {
    bottom: 75px;
  }

  &-position-bottom {
    top: 75px;
  }

  .tooltip-title {
    font-size: 16px;
    font-weight: 400;
    color: #242424;
  }

  .tooltip-text {
    font-size: 14px;
    color: #afafaf;
  }
}
</style>
